/* dede — karşılama pop-up'ı (snippets/welcome-popup.liquid).
   Sayfa boyandıktan sonra kısa bir gecikmeyle (ya da ilk kaydırmada) açılır; ana düğmesi
   ziyaretçiyi koku testine götürür. Düğme gerçek bir bağlantıdır: JS olmasa da çalışır,
   bu yüzden burada yönlendirme kodu yok — yalnızca ne zaman açılacağı ve kapanışı var. */
(function () {
var D = document, W = window, el = D.getElementById('WelcomePopup');
if (!el || el.__wp) return;
el.__wp = 1;

var KEY = 'dede-welcome';
var editor = el.hasAttribute('data-wp-editor');
var freq = el.getAttribute('data-wp-freq') || 'visit';
var scrollOn = el.getAttribute('data-wp-scroll') === '1';
var delay = parseInt(el.getAttribute('data-wp-delay'), 10);
if (isNaN(delay) || delay < 0) delay = 2500;
var shown = false, armed = 0, t1 = 0, prev = null, tries = 0, pressed = null;

// Sepet çekmecesi, mobil menü ya da filtre paneli açıkken araya girmez
function busy() {
  var c = D.documentElement.classList;
  return !!D.querySelector('dialog[open]') || c.contains('nav-lock') || c.contains('coll-lock');
}

// Sıklık: her ziyaret (oturum), günde bir, haftada bir
function due() {
  if (editor) return true;
  try {
    if (freq === 'visit') return sessionStorage.getItem(KEY) !== '1';
    var t = parseInt(localStorage.getItem(KEY + '-t'), 10) || 0;
    return Date.now() - t > (freq === 'week' ? 6048e5 : 864e5);
  } catch (e) { return true; }
}
function mark() {
  if (editor) return;
  try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  try { localStorage.setItem(KEY + '-t', String(Date.now())); } catch (e) {}
}

// Stil yalnızca açılacağı an yüklenir: ilk boyama hiç beklemez
function withCss(cb) {
  var href = el.getAttribute('data-wp-css');
  if (!href) return cb();
  var l = D.createElement('link'), done = false;
  var fin = function () { if (!done) { done = true; cb(); } };
  l.rel = 'stylesheet';
  l.href = href;
  l.onload = fin;
  l.onerror = fin;
  setTimeout(fin, 1200);
  D.head.appendChild(l);
}

function stop() {
  clearTimeout(t1);
  t1 = 0;
  W.removeEventListener('scroll', onScroll, { passive: true });
}

// başka bir pencere/panel açıksa susar ve biraz sonra yeniden dener (sessizce kaybolmaz)
function retry(ms) {
  if (tries++ > 12) { stop(); return; }
  clearTimeout(t1);
  t1 = setTimeout(open, ms);
}

function open() {
  if (shown || el.open) return;
  if (!due()) { stop(); return; }
  if (busy()) { retry(1000); return; }
  shown = true;
  stop();
  withCss(function () {
    if (busy()) { shown = false; retry(900); return; }
    prev = D.activeElement;
    try { el.showModal(); } catch (e) { return; }
    mark();
    D.documentElement.classList.add('wp-lock');
    var h = el.querySelector('.wp__h');
    if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} }
  });
}

// Kapanınca: sayfa yeniden kayabilir, odak geldiği yere döner
el.addEventListener('close', function () {
  pressed = null;
  D.documentElement.classList.remove('wp-lock');
  var back = prev && prev !== D.body && D.contains(prev) ? prev : D.getElementById('MainContent');
  prev = null;
  if (back) { try { back.focus({ preventScroll: true }); } catch (e) {} }
});

// Perdeye (panelin dışına) tıklama kapatır. Tıklama hem perdede başlamalı hem perdede bitmeli:
// panelin içinden dışarı sürükleyerek metin seçen ziyaretçinin penceresi kapanmasın.
el.addEventListener('pointerdown', function (e) { pressed = e.target; });
el.addEventListener('click', function (e) {
  var p = pressed;
  pressed = null;
  if (e.target === el && p === el) el.close();
});
var x = el.querySelector('[data-wp-close]');
if (x) x.addEventListener('click', function () { el.close(); });

// Ana düğmeye tıklayan ziyaretçi koku testine gidiyor: pencere arkada açık kalmasın
var go = el.querySelector('[data-wp-go]');
if (go) go.addEventListener('click', function () { mark(); try { el.close(); } catch (e) {} });

// ---- ne zaman açılsın ----
function onScroll() {
  if (Date.now() - armed < 700) return;
  if (W.pageYOffset > Math.min(420, W.innerHeight * 0.45)) open();
}
function arm() {
  // belirli bir bağlantıyla (çapa) gelen ziyaretçinin işini bölme
  if (W.location.hash || /customer_posted/.test(W.location.search)) return;
  if (!due()) return;
  armed = Date.now();
  t1 = setTimeout(open, Math.max(400, delay));
  if (scrollOn) W.addEventListener('scroll', onScroll, { passive: true });
}
function boot() {
  // iki kare bekler: sayfa boyanmadan hiçbir şey yapılmaz
  W.requestAnimationFrame(function () { W.requestAnimationFrame(arm); });
}
if (D.readyState === 'complete') boot();
else W.addEventListener('load', boot);

W.addEventListener('pagehide', function () { stop(); D.documentElement.classList.remove('wp-lock'); });
})();
